import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { Grid, IconButton, Tooltip } from "@mui/material";

import pages from "../../../constants/pages";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple}!important;
  color: ${colors.purple}!important;
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors.purple}!important;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({ tenants, loading }) {
  const navigate = useNavigate();
  let columns = [
    { name: "platform_name", label: "Platform Name" },

    {
      name: "email_platform",
      label: "Platform Email",
    },

    {
      name: "site_copyright",
      label: "Platform Site Copyright",
    },
    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Settings">
            <Icon>
              <CgEye
                style={{ height: "20px", width: "20px" }}
                onClick={() => {
                  let platformID =
                    row.platform_id === 0 ? "Verismart" : row.platform_id;
                  navigate(
                    pages.dynamicUiPageDetails.route +
                      "?platform_id=" +
                      platformID
                  );
                }}
              />
            </Icon>
          </Tooltip>
        </div>
      );
    }

    return value; // default
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          columns={columns}
          renderCell={renderCell}
          data={tenants}
        />
      </Grid>
    </Grid>
  );
}
